import { IconBrandWhatsapp } from '@tabler/icons-react';

export function WhatsAppFloat() {
  return (
    <a
      href="https://w.app/rzv1fu"
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      data-id="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110 active:scale-95"
    >
      <IconBrandWhatsapp size={42} stroke={1.5} />
    </a>
  );
}
